export const VIEW_TYPE = {
  loading: 'loading',
  redirecting: 'redirecting',
  project: 'project',
  error: 'error',
};
